export default "__VITE_ASSET__BbL5quUT__"